export default function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/super-x.blog/httpdocs/~/swiper/esm/components/core/classes/removeClasses.js
// module id = 453
// module chunks = 0